module.exports = __webpack_public_path__ + "img/7m.63f50be7.jpg";